<script setup lang="ts">
import { useClaimLabState } from '../composables/claim-lab'
import { useCurrentUser } from '../composables/user'

const router = useRouter()

const route = useRoute()

const state = useClaimLabState()

const config = useRuntimeConfig().public

/* Hosts that already provide the user's permissions (console) keep their own */
const currentUser = useCurrentUser()
if (!inject('user-permissions', null)) {
  provide(
    'user-permissions',
    computed(() => currentUser.value?.permissions ?? []),
  )
}

const isProviderInquiries = computed(
  () => config.groundcover.config.appId === 'provider-inquiries',
)

const onExit = () => {
  const { connectorId, claimId } = route.params as {
    connectorId: string
    claimId: string
  }

  router.push(
    isProviderInquiries.value
      ? `/${connectorId}/${claimId}`
      : `/claims/${claimId}?lob=${connectorId}`,
  )
}
</script>

<template>
  <div class="bg-default grid h-screen grid-rows-[auto_1fr] print:block">
    <header
      class="border-default flex items-center justify-between gap-4 border-b px-4 py-2"
    >
      <div class="flex items-center gap-2">
        <RialticLogo class="h-6 w-6" icon />
        <span class="text-sm font-medium">{{ state.connectorName }}</span>
      </div>

      <UButton
        class="print:hidden"
        aria-label="Close"
        color="neutral"
        label="Close"
        trailing-icon="i-ph-x-bold"
        variant="ghost"
        @click="onExit"
      />
    </header>
    <div class="relative overflow-hidden print:overflow-visible">
      <slot />
    </div>
  </div>
</template>
